import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconMetroPeOn(props) {
  return (
    <svg
        width={244}
        height={244}
        viewBox="0 0 244 244"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={122} cy={122} r={117} fill="#000" />
        <path
        d="M122 243.965c-67.268 0-122-54.724-122-121.982C0 54.725 54.732 0 122 0s122 54.725 122 121.993c0 67.248-54.722 121.972-122 121.972zm0-237.143C58.494 6.822 6.823 58.486 6.823 121.983s51.671 115.16 115.187 115.16c63.506 0 115.177-51.663 115.177-115.16S185.506 6.822 122 6.822z"
        fill="#000"
        />
        <path
        d="M182.225 36.76c0-10.723 8.713-19.405 19.428-19.405 10.724 0 19.408 8.682 19.408 19.405 0 10.703-8.684 19.405-19.408 19.405-10.705.01-19.428-8.692-19.428-19.405z"
        fill="#000"
        />
        <path
        d="M191.2,36.8c0-5.8,4.7-10.4,10.5-10.4s10.5,4.7,10.5,10.4c0,5.8-4.7,10.4-10.5,10.4C195.9,47.2,191.2,42.5,191.2,36.8z"
        fill="#FFDD00"
        />
        <path
        d="M57.5,174.2c0,0,11.3,1.1,15.2-10.1L98.3,105l-6,56.5c0,0-3,12.7,8.8,12.7h11.8c7.4,0,10.4-6.9,10.4-6.9l31.9-59.4l-9.5,55.3c-2.3,11.7,9.5,10.9,9.5,10.9h15.7l16-91.4h-26.1c-10.5,0-13.1,5.6-13.1,5.6l-27.5,49.6l4.4-44.7c1.3-11.6-11.9-10.5-11.9-10.5H88.8l-40.4,91.5H57.5z"
        fill="#FFDD00"
        />
    </svg>
  )
}

export default SvgIconMetroPeOn;